module.exports = __webpack_public_path__ + "images/187eeee718b8c696ca2045bf064e065d.jpg";